/**
 * Action Center sub-navigation.
 *
 * The sidebar now exposes a single "Action Center" entry (it lands on the
 * queue) instead of the old 4-item nested "Actions" menu. This strip lets the
 * user move between the four Action surfaces — Queue, History, Auto-Approval
 * Rules, Approval Settings — from any of them. Each tab is a NavLink, so the
 * active section is driven by the URL and every sub-route stays deep-linkable
 * (the routes themselves are unchanged — see `ActionsPage.tsx`).
 *
 * Rendered as the first child INSIDE each sub-page's content (below the fixed
 * Theme-2 title bar), so it scrolls with the page and never sits under the
 * fixed header.
 */
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './actions.scss';

interface ActionCenterTab {
  to: string;
  labelKey: string;
}

// #10 — the queue tab is labelled "Overview". #9 — History is hidden (still
// reachable by direct URL). #12 — Approval Settings is removed (superseded by
// Auto-Approval Rules).
const ACTION_CENTER_TABS: ActionCenterTab[] = [
  { to: '/actions/queue', labelKey: 'ActionCenterTabOverview' },
  { to: '/actions/rules', labelKey: 'ActionCenterTabRules' },
];

const ActionCenterTabs = () => {
  const { t } = useTranslation();

  return (
    <nav className='actionCenterTabs' aria-label={t('ActionCenter')}>
      {ACTION_CENTER_TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end
          className={({ isActive }) =>
            `actionCenterTabs__tab${
              isActive ? ' actionCenterTabs__tab--active' : ''
            }`
          }
        >
          {t(tab.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
};

export default ActionCenterTabs;
